import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import { inputStyles } from 'assets/components/inputs/Input';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import { getLocales } from 'assets/locales/Locale';
import { useClaimTypeProvider } from '../ClaimType.Hooks';
import Theme from 'assets/themes/Theme.Common';

export default function ClaimTypeFilters() {
  const { lang } = getLocales();
  const { listApi, productsApi, productCategoriesApi, providersApi } = useClaimTypeProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      filters={listApi.body}
      onOpen={() => {
        if (!productsApi.payload) productsApi.execute((body) => body);
        if (!providersApi.payload) providersApi.execute((body) => body);
        if (!productCategoriesApi.payload) productCategoriesApi.execute((body) => body);
      }}
      onFilter={(newFilters) => listApi.execute(newFilters)}
      onReset={listApi.reset}
      render={({ tempFilters, setFilters }) => {
        return (
          <>
            <SelectInput
              name="productCategoryId"
              label={lang.programs}
              data={productCategoriesApi?.payload?.data.map((item) => ({
                ...item.displayInfo,
                icon: <Icon class="fas-sitemap" />,
              }))}
              isMultiselect
              value={tempFilters?.productCategoryId}
              onChange={setFilters}
              icon={<Icon class="fas-sitemap" />}
            />
            <SelectInput
              name="providerId"
              label={lang.providers}
              data={providersApi?.payload?.data?.map((item) => ({
                ...item.displayInfo,
                icon: <Icon class="fas-building" />,
              }))}
              isMultiselect
              value={tempFilters?.providerId}
              onChange={setFilters}
              icon={<Icon class="fas-building" />}
            />
            <SelectInput
              name="productId"
              label={lang.products}
              data={productsApi?.payload?.data?.map((item) => ({
                ...item.displayInfo,
                title: item.name,
                icon: <Icon class="fas-box" />,
              }))}
              isMultiselect
              value={tempFilters?.productId}
              onChange={setFilters}
              icon={<Icon class="fas-box" />}
            />
            <CheckInput
              name="withDeleted"
              label={lang.withArchived}
              class={inputStyles.check.switch + ' formInput'}
              value={tempFilters?.withDeleted}
              onChange={({ withDeleted }) => setFilters({ withDeleted: Boolean(withDeleted) })}
              htmlElementProps={{ title: tempFilters?.withDeleted ? lang.disable : lang.enable }}
              style={{ marginTop: Theme.Size.M, alignSelf: 'center' }}
            />
          </>
        );
      }}
    />
  );
}
